var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSellectAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49984 2.91669V1.66669M4.21705 4.21724L3.33317 3.33335M4.21705 10.8334L3.33317 11.7173M10.8332 4.21724L11.7171 3.33335M2.9165 7.50002H1.6665M13.2203 13.4914L11.1438 17.3475C10.9066 17.7881 10.7879 18.0084 10.6453 18.0641C10.5214 18.1124 10.3819 18.0988 10.2698 18.0274C10.1406 17.945 10.067 17.7059 9.91967 17.2278L7.0375 7.87106C6.91717 7.48045 6.857 7.28513 6.90541 7.15321C6.94758 7.03831 7.03813 6.94776 7.15303 6.9056C7.28495 6.8572 7.48025 6.91735 7.87088 7.03768L17.2275 9.91985C17.7057 10.0672 17.9448 10.1409 18.0271 10.27C18.0986 10.3822 18.1122 10.5216 18.0638 10.6454C18.0082 10.7882 17.7878 10.9068 17.3473 11.144L13.4912 13.2204C13.4257 13.2557 13.3929 13.2733 13.3643 13.2959C13.3388 13.316 13.3158 13.339 13.2958 13.3645C13.2731 13.3931 13.2555 13.4259 13.2203 13.4914Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSellectAll);
export default __webpack_public_path__ + "static/media/sellect_all.3e0004e3ec4815bb93540cf2985e724a.svg";
export { ForwardRef as ReactComponent };